<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '50px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="5">
          <p>连续签到天数</p>
          <div class="main"  :key="index">
            <div class="left-box">
              <a-input v-model="result.signDay" style="width: 250px" />
            </div>
          </div>
        </a-col>
        <a-col :span="5">
          <p>获得积分</p>
          <div class="main"  :key="index">
            <div class="left-box">
              <a-input v-model="result.signIntegral" style="width: 250px" />
            </div>
          </div>
        </a-col>
        <a-col :span="5">
          <p>获得币数</p>
          <div class="main"  :key="index">
            <div class="left-box">
              <a-input v-model="result.coins" style="width: 250px" />
            </div>
          </div>
        </a-col>
        <!-- <a-col :span="5">
          <p>任务标题</p>
          <div class="main"  :key="index">
            <div class="left-box">
              <a-input v-model="result.taskTitle" style="width: 250px" placeholder="标题不要过长"/>
            </div>
          </div>
        </a-col> -->
        <a-col :span="8">
          <p>开始/结束时间</p>
          <div class="main"  :key="index">
            <div class="left-box">
               <a-range-picker v-model="dateTime" format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
            </div>
          </div>
        </a-col>
        
        <!-- <a-col :span="5">
          <p>任务描述</p>
          <div class="main"  :key="index">
            <div class="left-box">
              <a-input v-model="result.taskDesc" style="width: 250px" placeholder="可不填"/>
            </div>
          </div>
        </a-col> -->
      </a-row>
      <a-button class="a-button" @click="save">保存</a-button>
    </div>
  </div>
</template>

<script>
import { SigninRecord, SigninRecordEdit } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      result: 
        {
          signDay: "",
          signIntegral: "",
          taskTitle: "",
          taskDesc: "",
          startTime: "",
          endTime: "",
          coins: "",
        },
      dateTime: null,
      data: [],
      formInline: {
        user: "",
        password: "",
        store: "",
      },
    };
  },
  mounted() {
    this.getQianmignList();
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    getQianmignList() {
      SigninRecord().then((res) => {
        console.log('签到配置数据:', res);
        if (res.data && res.data != null && res.data.length > 0) {
          this.result = res.data[0];
          // 确保时间字段存在且格式正确
          if (this.result.startTime && this.result.endTime) {
            this.dateTime = [this.result.startTime, this.result.endTime];
            console.log('设置日期范围:', this.dateTime);
          } else {
            this.dateTime = null;
          }
        } 
        
      });
    },
    save() {
      console.log("sssssssss", this.result);
      SigninRecordEdit(this.result).then((res) => {
        message.success(res.data);
        this.getQianmignList();
      });
    },
    onChange(date, dateString) {
      this.result.endTime = dateString[1];
      this.result.startTime = dateString[0];
    },
  },
};
</script>

<style scoped>
.left-box {
  float: left;
  margin-left: 20px;
}
.right-box {
  float: right;
}
.a-button {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/checkinConfiguration/checkinConfiguration.vue